import type { PrepackageDestination } from '../../types';
import type { SearchIndexItem } from '../utils/destinationPicker';

export const destinationTypeLabels: Record<SearchIndexItem['type'], string> = {
    continent: 'Verdensdel',
    country: 'Land',
    region: 'Region',
    destination: 'Sted',
};

export const getDestinationName = (destination: PrepackageDestination): string => destination.label.split(',')[0];

export const getDestinationSummary = (destinations: PrepackageDestination[]): string => {
    if (destinations.length === 0) return '';
    if (destinations.length === 1) return getDestinationName(destinations[0]);
    return `${getDestinationName(destinations[0])} +${destinations.length - 1} til`;
};
